import { SelectorDevicesComponent } from "../selectorDevices/selectorDevices.component";
import { SelectorMediaComponent } from "../selectorMedia/selectorMedia.component";
import { SelectorStreamsProperties } from "./selectorStreams.properties";

import "../selectorDevices/selector.styles.scss";
import { useEffect, useState } from "react";
import { environment } from "../../../../environment";
import axios from "axios";

/**
 * Show media and devices selector in the same component to avoid multiple components
 *
 * @param props
 * @returns
 */
export default function SelectorStreams(props: SelectorStreamsProperties) {
  const [groupsData, setGroupsData] = useState<any[]>([]);
  const [hasDevicesBeenFetched, setHasDevicesBeenFetched] = useState(false);
  const [hasMediaBeenFetched, setHasMediaBeenFetched] = useState(false);
  const [canBeDisplayed, setCanBeDisplayed] = useState(false);

  useEffect(() => {
    if (hasDevicesBeenFetched && hasMediaBeenFetched) {
      setCanBeDisplayed(true);
    }
  }, [hasDevicesBeenFetched, hasMediaBeenFetched]);

  const getGroupData = async () => {
    axios.get(`${environment.api.host}/api/group/me?includeIcons=false`, {
      headers: {
          Authorization: `Bearer ${props.user.access_token}`
      }
    }).then((response) => {
      setGroupsData(response?.data?.items);
    });
  }

  useEffect(() => {
    getGroupData();

    const interval = setInterval(() => {
      getGroupData();
    }, 5000);

    return () => {
      clearInterval(interval);
    }
  }, []);


  return (
    <div className="SelectorComponent">
      <SelectorMediaComponent
        deviceInstance={props.deviceInstance}
        localScreams={props.localScreams || []}
        setScene={props.setScene}
        user={props.user}
        addStream={props.addStream}
        removeStream={props.removeStream}
        appsBeingUsed={props.appsBeingUsed}
        setAppsBeingUsed={props.setAppsBeingUsed}
        setIsShowingHelp={props.setIsShowingHelp}
        groupsData={groupsData}
        setHasMediaBeenFetched={setHasMediaBeenFetched}
        canBeDisplayed={canBeDisplayed}
        setMediaIconCache={props.setMediaIconCache}
        mediaIconCache={props.mediaIconCache}
        room={props.room}
      />

      <SelectorDevicesComponent
        deviceInstance={props.deviceInstance}
        localScreams={props.localScreams || []}
        mode={props.mode || "devices"}
        setScene={props.setScene}
        user={props.user}
        addStream={props.addStream}
        removeStream={props.removeStream}
        groupsData={groupsData}
        setHasDevicesBeenFetched={setHasDevicesBeenFetched}
        canBeDisplayed={canBeDisplayed}
        setDevicesIconCache={props.setDevicesIconCache}
        devicesIconCache={props.devicesIconCache}
        room={props.room}
        isMagicLeapConnected={props.isMagicLeapConnected}
        hasSpaceMouseInRoom={props.hasSpaceMouseInRoom}
        isSpaceMouseLinked={props.isSpaceMouseLinked}
        spaceMouseStatus={props.spaceMouseStatus}
        spaceMouseStatusDetail={props.spaceMouseStatusDetail}
        onLinkSpaceMouse={props.onLinkSpaceMouse}
        onUnlinkSpaceMouse={props.onUnlinkSpaceMouse}
        onOpenPairing={props.onOpenPairing}
      />
    </div>
  );
}
